export const getCatalogAssetUrl = (
  image: string | null | undefined,
  catalogAssetsUrl: string | undefined,
  cdnUrl: string,
): string => {
  if (!image || image === 'null' || image === 'undefined') {
    return catalogAssetsUrl ? `${catalogAssetsUrl}generic-trailer.svg` : ''
  }

  if (image.startsWith('catalog/')) {
    return `${catalogAssetsUrl || cdnUrl}${image.slice('catalog/'.length)}`
  }

  return `${cdnUrl}${image}`
}
